import { Alert } from '@material-ui/lab';
import styled, { css } from 'styled-components';

interface ErrorAlertProps {
  $forGrid?: boolean;
}

export const ErrorAlert = styled(Alert)<ErrorAlertProps>`
  ${(props) =>
    !props.$forGrid &&
    css`
      margin-top: 16px;
    `}
`;
